import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import {
  FETCH_IN_OUT_ORDER_TRANS,
  FETCH_IN_OUT_TRANS,
  FETCH_IN_OUT_TRANS_EXTERNAL,
  FETCH_TRANS,
  FETCH_ORDER_TRANS,
  FETCH_EXT_TRANS,
  FETCH_WALLET_BALANCE,
  FETCH_IN_OUT_ORDER_TRANS_CHART,
  FETCH_IN_OUT_TRANS_CHART,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART,
} from '../actions/statistic/action_types';
import actions from '../actions/statistic';
import rf from '../../requests/RequestFactory';
// saga effect

function* fetchInOutOrderTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchInOutOrderTrans(params), action.params);
    yield put(actions.fetchInOutOrderTransActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchInOutOrderTransActionFailed(err));
  }
}

function* fetchTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchTrans(params), action.params);
    yield put(actions.fetchTransActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchTransActionFailed(err));
  }
}

function* fetchOrderTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchOrderTrans(params), action.params);
    yield put(actions.fetchOrderTransActionSucceed({ data, market: `${action.params.coin}:${action.params.currency}` }));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchOrderTransActionFailed(err));
  }
}

function* fetchExternalTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchExtTrans(params), action.params);
    yield put(actions.fetchExtTransActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchExtTransActionFailed(err));
  }
}

function* fetchInOutTransaction(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchInOutTrans(params), action.params);
    yield put(actions.fetchInOutTransActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchInOutTransActionFailed(err));
  }
}

function* fetchInOutTransactionExternal(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchInOutTransExternal(params), action.params);
    yield put(actions.fetchInOutTransExternalActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchInOutTransExternalActionFailed(err));
  }
}

function* fetchWalletBalance(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchWalletBalance(params), action.params);
    yield put(actions.fetchWalletBalanceActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchWalletBalanceActionFailed(err));
  }
}

function* fetchInOutOrderTransactionChart(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchInOutOrderTransChart(params), action.params);
    yield put(actions.fetchInOutOrderTransActionChartSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchInOutOrderTransActionChartSucceed(err));
  }
}

function* fetchInOutTransactionChart(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchInOutTransChart(params), action.params);
    yield put(actions.fetchInOutTransChartActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchInOutTransChartActionFailed(err));
  }
}

function* fetchInOutTransactionExternalChart(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('StatisticRequest').fetchInOutTransExternalChart(params), action.params);
    yield put(actions.fetchInOutTransExternalChartActionSucceed(data));
  } catch (err) {
    console.log('err', err);
    yield put(actions.fetchInOutTransExternalChartActionFailed(err));
  }
}

function* watchStatistic() {
  yield takeLatest(FETCH_IN_OUT_ORDER_TRANS, fetchInOutOrderTransaction);
  yield takeLatest(FETCH_IN_OUT_TRANS, fetchInOutTransaction);
  yield takeLatest(FETCH_IN_OUT_TRANS_EXTERNAL, fetchInOutTransactionExternal);
  yield takeLatest(FETCH_WALLET_BALANCE, fetchWalletBalance);
  yield takeLatest(FETCH_TRANS, fetchTransaction);
  yield takeLatest(FETCH_EXT_TRANS, fetchExternalTransaction);
  yield takeLatest(FETCH_ORDER_TRANS, fetchOrderTransaction);
  yield takeLatest(FETCH_IN_OUT_ORDER_TRANS_CHART, fetchInOutOrderTransactionChart);
  yield takeLatest(FETCH_IN_OUT_TRANS_CHART, fetchInOutTransactionChart);
  yield takeLatest(FETCH_IN_OUT_TRANS_EXTERNAL_CHART, fetchInOutTransactionExternalChart);
}

export default function* rootSaga() {
  yield all([fork(watchStatistic)]);
}
